<div class="spacer40" *ngIf="hasExperimentalRole"></div>
<div
    class="col-12 algorithm-content"
    *ngIf="initialized && hasExperimentalRole"
>
    <div class="basic-param-wrapper">
        <div class="basic-param-title-wrapper">
            <p class="basic-param-title mb-0">
                {{ 'modelConfiguration.title' | translate }}
            </p>
        </div>
        <div class="row m-0 basic-param-content">
            <div class="col-4 col-xl-3 px-0 bg-color">
                <div class="col-content">
                    <app-dropdown
                        [control]="form.get('selectedModel')"
                        inputLabel="{{
                            'modelConfiguration.model' | translate
                        }}"
                        [options]="models"
                        (valueChange)="onSelectedModelChanged($event)"
                    >
                    </app-dropdown>
                    <div class="spacer40"></div>
                    <app-checkbox
                        *ngIf="displayTilingOption"
                        [control]="form.get('tilingActive')"
                        inputLabel="{{
                            'modelConfiguration.useTiling' | translate
                        }}"
                        (valueChange)="onTilingCheckboxChanged($event)"
                    >
                    </app-checkbox>
                </div>
            </div>
            <div class="col-4 col-xl-3 px-0 bg-color">
                <div class="col-content">
                    <app-checkbox
                        [control]="form.get('useImagesWithoutAnnotations')"
                        inputLabel="{{
                            'modelConfiguration.useUnlabeledImages' | translate
                        }}"
                        (valueChange)="
                            onIgnoreImagesWithoutAnnotationsChanged($event)
                        "
                    >
                    </app-checkbox>
                </div>
            </div>
        </div>
    </div>
</div>
